import { Browser, Device, Version } from "@kakaopay-common/user-agent";
import { moveToStore } from "./store.mjs";
const { APP_TYPE } = Browser;
const { OS_TYPE } = Device;
const targetAppMap = {
  [APP_TYPE.KAKAOPAY]: "payapp",
  [APP_TYPE.KAKAOPAY_BIZ]: "bizapp",
  [APP_TYPE.KAKAOTALK]: "talkpay"
};
const canUse = ({
  command,
  minVersion,
  userAgent
}) => {
  const currentOs = Device.getOsName(userAgent);
  const currentApp = Browser.checkApp(userAgent);
  const currentVersion = Browser.getAppVersion(userAgent);
  if (currentApp === APP_TYPE.UNKNOWN) {
    console.warn(`App 타입을 확인할 수 없습니다. (호출 JSAPI: ${command})`);
    return true;
  }
  if (currentOs === OS_TYPE.UNKNOWN) {
    console.warn(`OS 타입을 확인할 수 없습니다. (호출 JSAPI: ${command})`);
    return true;
  }
  if (!minVersion) {
    console.warn(`JSAPI의 최소 버전이 지정되지 않았습니다. (호출 JSAPI: ${command})`);
    return true;
  }
  const targetOS = currentOs === OS_TYPE.IOS ? "ios" : "android";
  const targetApp = targetAppMap[currentApp];
  const minAppVersion = minVersion[targetOS][targetApp];
  if (minAppVersion === null) {
    console.error(
      `현재 환경에서는 지원되지 않는 JSAPI입니다. [현재환경: ${targetOS} / ${targetApp}] (호출 JSAPI: ${command})`
    );
    return false;
  }
  if (minAppVersion === "") {
    console.warn(
      `JSAPI의 최소 지원 버전의 업데이트가 필요합니다. (minVersion = '') (호출 JSAPI: ${command})`
    );
    return true;
  }
  const canUse2 = Version.isGreaterThanOrEqualTo(currentVersion, minAppVersion);
  if (!canUse2) {
    console.error(
      `현재 앱 버전이 최소 지원버전보다 낮습니다. [현재환경: ${targetOS} / ${targetApp}] [현재버전: ${currentVersion}] [최소버전: ${minAppVersion}] (호출 JSAPI: ${command})`
    );
    if (minVersion.useUpdate) {
      moveToStore();
      return false;
    }
  }
  return canUse2;
};
const notSupportedResponse = (command) => ({
  success: false,
  command,
  extras: {
    identifier: ""
  },
  error: {
    code: "NOT_SUPPORTED_VERSION",
    message: `지원하지 않는 버전입니다. (${command})`
  }
});
export {
  canUse,
  notSupportedResponse
};
